module.exports = __webpack_public_path__ + "static/media/Shoe_BlueRedInside.2585b0d4.png";